/// <reference path="../../Controls/CertificateDialog/SetServerCertificateAttributes/SetServerCertificateAttributes.ts"/>
/// <reference path="../../Controls/CertificateDialog/UploadServerCsr/UploadServerCsr.ts"/>

module EEX.McEc {

    export module Apps {
        import SetPrivateKeyPasswordModel = McEc.Controls.CertificateDialog.SetPrivateKeyPasswordModel;
        import SetPrivateKeyPasswordView = McEc.Controls.CertificateDialog.SetPrivateKeyPasswordView;
        import CreatePrivateKeyModel = McEc.Controls.CertificateDialog.CreatePrivateKeyModel;
        import CreatePrivateKeyView = McEc.Controls.CertificateDialog.CreatePrivateKeyView;
        import UploadCsrAndRequestCertificateModel = McEc.Controls.CertificateDialog.UploadCSRAndRequestCertificateModel;
        import UploadCsrAndRequestCertificateView = McEc.Controls.CertificateDialog.UploadCSRAndRequestCertificateView;
        import SavePkcsFileModel = McEc.Controls.CertificateDialog.SavePkcsFileModel;
        import SavePkcsFileView = McEc.Controls.CertificateDialog.SavePkcsFileView;
        import CertificateDialogModel = McEc.Controls.CertificateDialog.CertificateDialogModel;
        import SetPKCSFilePasswordModel = McEc.Controls.CertificateDialog.SetPKCSFilePasswordModel;
        import SetPKCSFilePasswordView = McEc.Controls.CertificateDialog.SetPKCSFilePasswordView;
        import SavePrivateKeyModel = McEc.Controls.CertificateDialog.SavePrivateKeyModel;
        import SavePrivateKeyView = McEc.Controls.CertificateDialog.SavePrivateKeyView;
        import UserInfo = AppKitchen.Api.Models.UserInfo;
        import CreatePrivateKeyCommand = McEc.Commands.CreatePrivateKeyCommand;
        import RequestCertificateCommand = McEc.Commands.RequestCertificateCommand;
        import SavePrivateKeyToFileCommand = McEc.Commands.SavePrivateKeyToFileCommand;
        import CreateAndSavePkcsFileCommand = McEc.Commands.CreateAndSavePkcsFileCommand;
        import CertificateModel = McEc.Domain.CertificateModel;
        import ChooseKeyPairSourceModel = McEc.Controls.CertificateDialog.ChooseKeyPairSourceModel;
        import ChooseKeyPairSourceView = McEc.Controls.CertificateDialog.ChooseKeyPairSourceView;
        import UploadPrivateKeyModel = McEc.Controls.CertificateDialog.UploadPrivateKeyModel;
        import UploadPrivateKeyView = McEc.Controls.CertificateDialog.UploadPrivateKeyView;
        import GetKeyPairFromFileCommand = McEc.Commands.GetKeyPairFromFileCommand;
        import ReadPrivateKeyFileCommand = McEc.Commands.ReadPrivateKeyFileCommand;
        import SetServerCertificateAttribtuesModel = McEc.Controls.CertificateDialog.SetServerCertificateAttribtuesModel;
        import SetServerCertificateAttribtuesView = McEc.Controls.CertificateDialog.SetServerCertificateAttributesView;
        import UploadServerCsrModel = McEc.Controls.CertificateDialog.UploadServerCsrModel;
        import UploadServerCsrView = McEc.Controls.CertificateDialog.UploadServerCsrView;

        // ReSharper disable once InconsistentNaming
        export interface ServerCertificateCreateDialogOptions extends AppKitchen.AppBaseOptions {
            userInfo: UserInfo,
            authorityId: string,
            close: (certificateKey?: number, store?: Pki.Store, certificateFile?: string) => void
        }

        export class ServerCertificateCreateDialogApp extends AppKitchen.AppBase<ServerCertificateCreateDialogOptions> {

            public start() {
                let userInfo = this.options.userInfo;

                let model = new CertificateDialogModel({
                    userInfo: userInfo,
                    currentProcessStep: 1,
                    totalProcessSteps: 5,
                    isServerCertificate: true,
                });

                let createAndSavePkcsFileCommand = new CreateAndSavePkcsFileCommand();
                let createPrivateKeyCommand = new CreatePrivateKeyCommand();
                let savePrivateKeyToFileCommand = new SavePrivateKeyToFileCommand();
                let requestCertificateCommand = new RequestCertificateCommand(this.options.authorityId, true);
                //let getKeyPairFrimFileCommand = new GetKeyPairFrimFileCommand();
                //let readPrivateKeyFileCommand = new ReadPrivateKeyFileCommand();

                //let chooseKeyPairSourceModel = new ChooseKeyPairSourceModel(model, 1);
                //let chooseKeyPairSourceView = new ChooseKeyPairSourceView(chooseKeyPairSourceModel, this.el);

                //let uploadPrivateKeyModel = new UploadPrivateKeyModel(model, 2, readPrivateKeyFileCommand, getKeyPairFrimFileCommand);
                //let uploadPrivateKeyView = new UploadPrivateKeyView(uploadPrivateKeyModel, this.el);

                let createPrivateKeyModel = new CreatePrivateKeyModel(model, 1, createPrivateKeyCommand);
                let createPrivateKeyView = new CreatePrivateKeyView(createPrivateKeyModel, this.el);

                let setPrivateKeyPasswordModel = new SetPrivateKeyPasswordModel(model, 2);
                let setPrivateKeyPasswordView = new SetPrivateKeyPasswordView(setPrivateKeyPasswordModel, this.el);

                let savePrivateKeyModel = new SavePrivateKeyModel(model, 3, savePrivateKeyToFileCommand);
                let savePrivateKeyView = new SavePrivateKeyView(savePrivateKeyModel, this.el);

                let setServerCertificateAttribtuesModel = new SetServerCertificateAttribtuesModel(model, 4);
                let setServerCertificateAttribtuesView = new SetServerCertificateAttribtuesView(setServerCertificateAttribtuesModel, this.el);

                let uploadServerCrsModel = new UploadServerCsrModel(model, 5, requestCertificateCommand);
                let uploadServerCsrView = new UploadServerCsrView(uploadServerCrsModel, this.el);

                //let uploadCrsAndRequestCertificateModel = new UploadCsrAndRequestCertificateModel(model, 5, requestCertificateCommand);
                //let uploadCsrAndRequestCertificateView = new UploadCsrAndRequestCertificateView(uploadCrsAndRequestCertificateModel, this.el);

                //let setPkcsFilePasswordModel = new SetPKCSFilePasswordModel(model, 6);
                //let setPkcsFilePasswordView = new SetPKCSFilePasswordView(setPkcsFilePasswordModel, this.el);  

                //let savePkcsFileModel = new SavePkcsFileModel(model, 7, createAndSavePkcsFileCommand);
                //let savePkcsFileView = new SavePkcsFileView(savePkcsFileModel, this.el);


                //chooseKeyPairSourceView.createNew(() => {
                //    createPrivateKeyView.render();
                //});

                //chooseKeyPairSourceView.chooseExisting(() => {
                //    uploadPrivateKeyView.render();
                //});

                //uploadPrivateKeyView.next(() => {
                //    setServerCertificateAttribtuesView.render();
                //});

                //uploadPrivateKeyView.prev(() => {
                //    chooseKeyPairSourceView.render();
                //});

                createPrivateKeyView.next(() => {
                    setPrivateKeyPasswordView.render();
                }, true);

                //createPrivateKeyView.prev(() => {
                //    chooseKeyPairSourceView.render();
                //});

                setPrivateKeyPasswordView.next(() => {
                    savePrivateKeyView.render();
                });

                savePrivateKeyView.next(() => {
                    setServerCertificateAttribtuesView.render();
                });

                setServerCertificateAttribtuesView.next(() => {
                    uploadServerCsrView.render();
                });

                uploadServerCsrView.finish(() => {
                    this.options.close();
                });

                //uploadCsrAndRequestCertificateView.next(() => {
                //    setPkcsFilePasswordView.render();
                //});

                //uploadCsrAndRequestCertificateView.finish(() => {
                //    this.options.close();
                //});

                //setPkcsFilePasswordView.next(() => {
                //    savePkcsFileView.render();
                //});

                //savePkcsFileView.finish(() => {
                //    let certificateKey = model.get().certificateKey;
                //    let store = model.get().store;
                //    let certificateFile = model.get().certificateFile;
                //    this.options.close(certificateKey, store, certificateFile);
                //});

                //chooseKeyPairSourceView.render();
                createPrivateKeyView.render();
            }
        }
    }
}